export const getCached = (key, maxAgeMinutes = 60) => {
  try {
    const item = sessionStorage.getItem(key);
    if (!item) return null;

    const { data, timestamp } = JSON.parse(item);
    if (Date.now() - timestamp > maxAgeMinutes * 60 * 1000) {
      sessionStorage.removeItem(key);
      return null;
    }
    return data;
  } catch {
    return null;
  }
};

export const setCached = (key, data) => {
  sessionStorage.setItem(
    key,
    JSON.stringify({ data, timestamp: Date.now() })
  );
};
